/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import { useParams } from "react-router-dom";
import useSTR from "react-str";
import { ShowMessage } from "../../components/ShowMessage";
import { routeURL } from "../../constants/commons";
import { ErrorComponent } from "../../molecules/ErrorComponent";
import { getData } from "../../utils/fetchers";
import { showDisplayHeadingAndContentFromLoadingStatus } from "../../utils/helpers";
import { preSignedURLPageStyle } from "./styles";
import * as _ from "lodash";

interface PreSignedURLInterface {}

export const PreSignedSelfieVideoPage: React.FunctionComponent<PreSignedURLInterface> = (
  props
) => {
  const { uploadType, userId } = useParams() as any;

  // State to maintain the custom entered CITY
  const [urlList, setUrlList] = React.useState<any>();

  // [GET] On page load, for fetching the details from ZOHO
  const [
    ,
    {
      result: getPreSignedURL,
      revalidator: refetchPreSignedURL,
      loading,
      error: getAPIError,
    },
  ] = useSTR(getData);

  // Hook called on page load
  React.useEffect(() => {
    userId &&
      refetchPreSignedURL(
        `${routeURL.selfieVideoPreSignedURLPage(userId, uploadType)}`
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  // Hook which fetches the details from GET API
  React.useEffect(() => {
    getPreSignedURL &&
      getPreSignedURL?.signedUrlContent &&
      setUrlList(getPreSignedURL?.signedUrlContent);
  }, [getPreSignedURL]);

  const displayVideosListArray = React.useCallback(() => {
    return (
      urlList &&
      _.keys(urlList).length > 0 &&
      _.map(urlList, (data, key) => {
        const { filename, url } = data;
        return (
          <li key={key}>
            <a href={url} target="_blank" rel="noopener noreferrer">
              {filename}
            </a>
          </li>
        );
      })
    );
  }, [urlList]);

  return (
    <span css={preSignedURLPageStyle}>
      <div className="container mt-5">
        <div className="row mt-5">
          <div className="col-md-12 mt-5">
            <ShowMessage
              visible={loading}
              loading={loading}
              heading={
                showDisplayHeadingAndContentFromLoadingStatus({
                  preLoginScreen: loading,
                })?.loadingHeading
              }
              description={
                showDisplayHeadingAndContentFromLoadingStatus({
                  preLoginScreen: loading,
                })?.loadingDescription
              }
            />
            <div className="col-md-12">
              <h4>List of videos uploaded</h4>
              {displayVideosListArray()}
            </div>
            {getAPIError && <ErrorComponent errorObj={getAPIError} />}
          </div>
        </div>
      </div>
    </span>
  );
};
